module.exports = __webpack_public_path__ + "static/media/uph_0001.973fe549.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/uph_0001.jpg
// module id = 632
// module chunks = 0